import React from 'react'
import PropTypes from 'prop-types'

import FileUploadBox from './FileUploadBox'

export default class ImagesUploader extends React.Component {
  static propTypes = {
    onDropFiles: PropTypes.func,
    label: PropTypes.string,
  }

  onDropFiles = e => {
    e.preventDefault()
    const files = e.target.files

    if (this.props.onDropFiles) {
      this.props.onDropFiles(files)
    }
  }

  render() {
    return (
      <FileUploadBox
        label={this.props.label ? this.props.label : 'Upload Image'}
        onChange={this.onDropFiles}
        multiple
      >
        {this.props.children}
      </FileUploadBox>
    )
  }
}


// WEBPACK FOOTER //
// ./src/modules/images-upload/ImagesUploader.js